// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__y_sfv"};